import { render, staticRenderFns } from "./CalendarReminderItem.vue?vue&type=template&id=4c548ee8&"
import script from "./CalendarReminderItem.vue?vue&type=script&lang=js&"
export * from "./CalendarReminderItem.vue?vue&type=script&lang=js&"
import style0 from "./CalendarReminderItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c548ee8')) {
      api.createRecord('4c548ee8', component.options)
    } else {
      api.reload('4c548ee8', component.options)
    }
    module.hot.accept("./CalendarReminderItem.vue?vue&type=template&id=4c548ee8&", function () {
      api.rerender('4c548ee8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/calendar/calendar-event-handler/CalendarReminderItem.vue"
export default component.exports